import { takeLatest, put, call } from 'redux-saga/effects';

import { findCulturaCadastro } from '../service';
import {
  FIND_CULTURA_CADASTRO,
  FIND_CULTURA_CADASTRO_PENDING,
  FIND_CULTURA_CADASTRO_SUCCESS,
  FIND_CULTURA_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaFindCulturaCadastro(action) {
  yield put({ type: FIND_CULTURA_CADASTRO_PENDING, id: action.id })

  try {

    const registro = yield call(findCulturaCadastro, action.id);

    yield put({ type: FIND_CULTURA_CADASTRO_SUCCESS, registro: registro })

  } catch (error) {

    yield put({ type: FIND_CULTURA_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchFindCulturaCadastro() {
  yield takeLatest(FIND_CULTURA_CADASTRO, sagaFindCulturaCadastro)
}
